import React from 'react';
import { Alert, Stack, Text } from '@mantine/core';
import { IconDeviceMobileOff } from '@tabler/icons-react';

export default function MobileUnsupportedNotice() {
  return (
    <Alert
      color="orange"
      variant="light"
      title="Non disponible sur téléphone"
      icon={<IconDeviceMobileOff size={20} />}
    >
      <Stack gap="xs">
        <Text size="sm">
          JFL Contrôle n&apos;est pas utilisable sur téléphone mobile.
        </Text>
        <Text size="sm" c="dimmed">
          Connectez-vous depuis un ordinateur ou une tablette.
        </Text>
      </Stack>
    </Alert>
  );
}
